import React, { useState } from "react";
import LoginFooter from "./LoginFooter";
import logo from "../../images/LOGO.png"
import loginBg from "../../images/BG.png";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { forgetPassword } from "../../actions/authAction";
import Alert from "../Alert";
import { Helmet } from "react-helmet";
import { appName } from "../../global/global";

const ForgetPassword = () => {

    const dispatch = useDispatch();
    const brandName = useSelector(state => state.rebrand.data);
    const rebrandData = useSelector(state => state.rebrand.data);

    const [loader, setLoader] = useState(false);
    const [emailDetails, setEmailDetails] = useState({
        email: ''
    })

    const onInputChange = (e) => {
        setEmailDetails({ ...emailDetails, email: e.target.value });
    }

    const onFormSubmit = (e) => {
        e.preventDefault();
        setLoader(true);

        dispatch(forgetPassword(emailDetails, setLoader));
    }

    return (
        <>
            <Helmet>
                <title>{brandName !== false ? brandName.name : appName}| Forget Password </title>
            </Helmet>
            <Alert />
            <section className="logoimg" style={{ backgroundImage: "url(" + loginBg + ")" }}>
                <div className="container">
                    <div className="row pt-4">
                        <div className="col-md-4">
                            <div className="logo">
                                <img src={logo} alt="logo" />
                            </div>
                        </div>
                    </div>

                    <div className="login-box">
                        <div className="row">
                            <div className="col-lg-6 d-flex align-items-center">
                                <div className="login-content text-white text-center">
                                    <h1><span>Welcome To </span> {rebrandData?.name ? rebrandData?.name : appName}!</h1>
                                    <p>Instantly Turn Any Webpage Into a Traffic-Getting Video At The Push of a
                                        Button!</p>
                                    <h5 className="mt-3">…It’s Super Easy-To-Use</h5>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <form className="login-form text-white" method="post" onSubmit={(e) => onFormSubmit(e)}>
                                    <h4><span>Enter </span> Your Email Address</h4>
                                    <div className="form-group mt-4">
                                        <label>Email Address</label>
                                        <input type="email" className="form-control" placeholder="Enter Email"
                                            required
                                            onChange={(e) => onInputChange(e)}
                                        />
                                    </div>
                                    <button type="submit" className="form-control btn-change6 mt-4" disabled={loader}>
                                        {loader ? <i className="fa fa-spinner fa-spin mr-2" /> : ''} Submit
                                    </button>
                                    <div className="forgot text-center mt-4">
                                        <Link to="/login" className="text-center ">
                                            Login ? <span>Click here</span></Link>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>

                </div>

                <LoginFooter />

            </section>

        </>
    )
}

export default ForgetPassword;